import { MutationTree, ActionTree, ActionContext } from 'vuex';
// import Cookies from 'js-cookie';
import { createStore } from 'vuex'
import { LoginParams, UserInfo, Notification, Menu } from '../config/types';

// Request Data Url
const LOGIN_URL = '/login';
const QUERY_URL = '/queryUserInfo';
const NOTIFICATION_URL = '/notification';
const MENU_URL = '/menu';

// State
export type State = {
  userInfo: Partial<UserInfo>;
  notifications: Notification[];
  menu: Menu[];
  userMenu: Menu[];
  showLayout: boolean,
  user: any,
  userRoute: string[],
  globalLoading: boolean
};

const state: State = {
  // userInfo: {},
  notifications: [],
  menu: [],
  userMenu: [],

  showLayout: true,
  user: {},
  userInfo: null,
  userRoute: [],
  globalLoading: true
};

// Mutations
export enum MutationTypes {
  SET_NOTIFICATION = 'SET_NOTIFICATION',
  SET_MENU = 'SET_MENU',
  SET_USER_MENU = 'SET_USER_MENU',

  SET_LAYOUT = 'SET_LAYOUT',
  SET_USER = 'SET_USER',
  SET_USERINFO = 'SET_USERINFO',
  SET_USERMENU = 'SET_USERMENU',
  SET_USERROUTE = 'SET_USERROUTE',
  SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING'
}

type Mutations<S = State> = {
  [MutationTypes.SET_NOTIFICATION](state: S, payload: Notification[]): void;
  [MutationTypes.SET_MENU](state: S, payload: Menu[]): void;
  [MutationTypes.SET_USER_MENU](state: S, payload: Menu[]): void;

  [MutationTypes.SET_LAYOUT](state: S, payload: boolean): void;
  [MutationTypes.SET_USER](state: S, payload: any): void;
  [MutationTypes.SET_USERINFO](state: S, payload: any): void;
  [MutationTypes.SET_USERMENU](state: S, payload: any): void;
  [MutationTypes.SET_USERROUTE](state: S, payload: any): void;
  [MutationTypes.SET_GLOBAL_LOADING](state: S, payload: any): void;
};

const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_NOTIFICATION](state, payload: Notification[]) {
    state.notifications = payload;
  },
  [MutationTypes.SET_MENU](state, payload: Menu[]) {
    state.menu = payload;
  },
  [MutationTypes.SET_USER_MENU](state, payload: Menu[]) {
    state.userMenu = payload;
  },

  [MutationTypes.SET_LAYOUT](state, payload: boolean) {
    state.showLayout = payload;
  },
  [MutationTypes.SET_USER](state, payload: any) {
    state.user = payload;
  },
  [MutationTypes.SET_USERINFO](state, payload: UserInfo) {
    state.userInfo = payload;
  },
  [MutationTypes.SET_USERMENU](state, payload: Menu[]) {
    state.userMenu = payload;
  },
  [MutationTypes.SET_USERROUTE](state, payload: string[]) {
    state.userRoute = payload;
  },
  [MutationTypes.SET_GLOBAL_LOADING](state, payload: boolean) {
    state.globalLoading = payload;
  },
};

// Actions
export enum ActionTypes {
  LOGIN = 'LOGIN',
  QUERY = 'QUERY',
  NOTIFICATION = 'NOTIFICATION',
  MENU = 'MENU',
}

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, State>, 'commit'>;

interface Actions {
  [ActionTypes.LOGIN]({ commit }: AugmentedActionContext, payload: LoginParams): Promise<any>;
  [ActionTypes.QUERY]({ commit }: AugmentedActionContext, id: number): Promise<any>;
  [ActionTypes.NOTIFICATION]({ commit }: AugmentedActionContext): Promise<any>;
  [ActionTypes.MENU]({ commit }: AugmentedActionContext, locale: string): Promise<any>;
}

// const actions: ActionTree<State, State> & Actions = {
//   async [ActionTypes.LOGIN]({ commit }, payload: LoginParams) {
//     const { data } = await this.$request.post(LOGIN_URL, payload);
//     if (data) {
//       commit(MutationTypes.SET_USERINFO, data);
//       // Cookies.set(userToken, data.id.toString(), {
//       //   expires: 1,
//       // });
//     }
//   }
// };

// named default
export default createStore({
  state,
  mutations
})
